import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FileCard = props => {
  const { file, handleRemove, showRemove } = props;
  return (
    <div className="fileCardUploader">
      <div>{file.fileName}</div>
      {showRemove && (
        <div style={{ zIndex: 2 }} onClick={() => handleRemove(file)}>
          <FontAwesomeIcon
            style={{ cursor: "pointer", color: "#d82829" }}
            icon={["far", "trash-alt"]}
          />
        </div>
      )}
    </div>
  );
};

export default FileCard;
